<template>
  <task-order :loaded="loaded" :loadErr="loadErr" :data="data" :reportDataId="reportDataId"></task-order>
</template>
<script>
import taskOrder from "./index";
export default {
  components: {
    taskOrder,
  },
  computed: {
    reportDataId() {
      return this.$route.query.reportDataId;
    },
  },
  data() {
    return {
      data: {},
      loading: false,
      loaded: false,
      loadErr: false,
    };
  },
  methods: {
    getTaskOrderMessage() {
      this.loading = true;
      this.$store
        .dispatch("getTaskOrderMessage", this.reportDataId)
        .then((res) => {
          this.data = res;
          this.loading = false;
          this.loaded = true;
        })
        .catch((err) => {
          this.loading = false;
          this.loadErr = true;
        });
    },
  },
  created() {
    this.getTaskOrderMessage();
  },
};
</script>
<style module lang="less"></style>
